import { get } from "lodash";

const localeCompareOptions = { sensitivity: "base" };
export const sortAlphabeticallyBy =
  (field: any) =>
  <T extends Record<string, any>>(a: T, b: T): number => {
    const keyA = get(a, field);
    const keyB = get(b, field);
    return keyA.localeCompare(keyB, localeCompareOptions);
  };
